<div class="panel panel-main mb-2">
    <div class="panel-heading py-2 px-3">
        <h3 appTitleProvider>{{ 'EMPLOYEES_TITLE' | translate }}</h3>
        <div class="panel-heading-keys">
            <span class="d-flex align-items-center" data-qa="qa-active-employees-label">
                |&nbsp;
                <span [innerHTML]="'ACTIVE_COUNT' | translate: { value: totalActiveEmployees }"></span>
                <div id="drop-box" class="drop-box invisible" cdkDropList (cdkDropListDropped)="findBestAll($event)">
                    <tr class="drop-empty-row drop-find-all">
                        <span>{{ 'FIND_BEST_EMPLOYEE' | translate }}</span>
                    </tr>
                </div>
            </span>
            <app-search placeholder="{{ 'ROUTE_PLANNING_EMPLOYEE_SEARCH_PLACEHOLDER' | translate }}"
                        (search)="searchTextChange($event)"></app-search>
        </div>
    </div>
    <div class="panel-body pb-2 px-3">
        <app-table
            class="employee-table"
            [loadingItems]="loading"
            [rowSelection]="!updating"
            [disableHover]="tableHoverEffectDisabled"
            [keyboardNavigation]="true"
        >
            <ng-container header>
                @if (swapModeActive) {
                    <th class="icon-column"></th>
                }
                <th class="flex-3" appHeaderSort="employeeName" appTitleProvider>
                    <span>{{ 'NAME' | translate }}</span>
                </th>
                @if (showRoster) {
                    <th class="flex-2" appHeaderSort="rosterDepartmentName" appTitleProvider>
                        <span>{{ 'ROSTER_NAME' | translate }}</span>
                    </th>
                }
                <th class="flex-2" appHeaderSort="skillLevelDescription" appTitleProvider>
                    <span>{{ 'COMPETENCE' | translate }}</span>
                </th>
                <th class="flex-2" appHeaderSort="transport" appTitleProvider>
                    <span>{{ 'TRANSPORT' | translate }}</span>
                </th>
                <th class="flex-2" appHeaderSort="fromTime,toTime" appTitleProvider>
                    <span>{{ 'SHIFT_TIME' | translate }}</span>
                </th>
                @if (rideSharingInRoute) {
                    <th class="icon-column"></th>
                }
                <th class="icon-column"></th>
            </ng-container>
            <ng-container body>
                @for (employee of displayEmployees; track employee) {
                    <tr
                        [ngClass]="{
                            'active': employee.selected,
                            'swap-selected': selectedSwapEmployees.has(employee) && !employee.selected
                        }"
                        cdkDropList
                        [cdkDropListData]="employee.allocatedTasks"
                        (cdkDropListDropped)="taskDropped($event, employee)"
                        (cdkDropListEntered)="taskEntered($event, employee)"
                        cdkScrollable
                        (click)="selectEmployee(employee)"
                    >
                        @if (swapModeActive) {
                            <td class="icon-column" (click)="handleSwapCellClick(employee)">
                                <app-checkbox
                                    [disable]="isDisabledSwap(employee)"
                                    [ngModel]="selectedSwapEmployees.has(employee)"
                                    (ngModelChange)="updateEmployeeSwapSelection(employee, $event)"
                                    [id]="employee.employeeId + '-swap-' + employee.fromTime + '-' + employee.toTime"
                                    (click)="$event.stopPropagation()"
                                >
                                </app-checkbox>
                            </td>
                        }
                        <td class="flex-3">
                            <span appTitleProvider>{{ employee.employeeName }}</span>
                        </td>
                        @if (showRoster) {
                            <td class="flex-2">
                                <span appTitleProvider>{{ employee.rosterDepartmentName }}</span>
                            </td>
                        }
                        <td class="flex-2">
                            <span appTitleProvider>{{ employee.skillLevelDescription }}</span>
                        </td>
                        <td class="flex-2" appTitleProvider>{{ employee.transport.toUpperCase() | translate }}</td>
                        <td class="flex-2 justify-content-between">
                            <span appTitleProvider>
                                {{ employee | fromto }}
                                @if (employee.shiftCode) {
                                    <span>({{ employee.shiftCode }})</span>
                                }
                            </span>
                        </td>
                        @if (rideSharingInRoute) {
                            <td class="icon-column">
                                @if (isRideSharingInEmployeeRoute(employee)) {
                                    <app-tooltip
                                        class="mx-auto"
                                        appCustomPopover
                                        placement="top"
                                        popoverText="RIDE_SHARING"
                                        [adaptPlacement]="true"
                                    >
                                        <ng-container icon>
                                            <img src="/assets/images/icons/24_car_ride_sharing.svg"
                                                 alt="{{'RIDE_SHARING' | translate}}">
                                        </ng-container>
                                    </app-tooltip>
                                }
                            </td>
                        }
                        <td class="icon-column">
                            @if (employee.lateArrivals) {
                                <app-tooltip
                                    appCustomPopover
                                    placement="top"
                                    [popoverText]="
                                        !highlightDelaysEnabled ? 'LATE_ARRIVALS_WARNING_INFO' :
                                        employee.routeDelay | delayTooltip"
                                    [adaptPlacement]="true"
                                >
                                    <ng-container icon>
                                        @if (highlightDelaysEnabled) {
                                            <span
                                                class="vismaicon vismaicon-sm mr-1"
                                                [ngClass]="{
                                                'icon-warning-multicolor': employee.routeDelay === DelayLevel.ShortDelay,
                                                'icon-warning-multicolor-orange': employee.routeDelay === DelayLevel.MediumDelay,
                                                'icon-warning-multicolor-red': employee.routeDelay === DelayLevel.SevereDelay,
                                            }"
                                            ></span>
                                        } @else {
                                            <span
                                                class="vismaicon vismaicon-sm vismaicon-filled vismaicon-warning mr-1"
                                            ></span>
                                        }
                                    </ng-container>
                                </app-tooltip>
                            }
                            @if (employee.hasUnpairedSyncTask) {
                                <app-tooltip
                                    appCustomPopover
                                    placement="top"
                                    popoverText="SYNCED_TASK_NOT_PAIRED_EMPLOYEE_ASSIGNED"
                                    [adaptPlacement]="true"
                                >
                                    <ng-container icon>
                                        <span
                                            class="vismaicon vismaicon-sm mx-1 vismaicon-filled vismaicon-error"
                                        ></span>
                                    </ng-container>
                                </app-tooltip>
                            } @else if (employee.hasUnsyncedTimeTask) {
                                <app-tooltip
                                    appCustomPopover
                                    placement="top"
                                    popoverText="SYNCED_TASK_NOT_TIME_SYNCED_EMPLOYEE"
                                    [adaptPlacement]="true"
                                >
                                    <ng-container icon>
                                        <span
                                            class="vismaicon vismaicon-sm mx-1 vismaicon-filled vismaicon-error"
                                        ></span>
                                    </ng-container>
                                </app-tooltip>
                            }
                        </td>
                    </tr>
                }
            </ng-container>
        </app-table>
        @if (!rideSharingInRoute && swapWorklistsFeature | async) {
            <div class="d-inline-flex">
                @if (!swapModeActive) {
                    <button type="button" class="btn btn-primary btn-swap-worklists d-inline-flex pl-1 pr-2 my-auto"
                            (click)="switchSwapMode()">
                        <span class="my-auto vismaicon vismaicon-md icon-replace mx-1"></span>
                        <span class="my-auto">{{ 'SWAP_WORKLISTS' | translate }}</span>
                    </button>
                } @else {
                    <button [disabled]="selectedSwapEmployees.size < maxSwapEmployees || updating"
                            (click)="openSwapModal()"
                            type="button" class="btn btn-primary btn-continue-swap d-inline-flex px-2 mr-2 my-auto">
                        <span class="m-auto">{{ 'CONTINUE_SWAP' | translate }}</span>
                    </button>
                    <button type="button" class="btn btn-secondary btn-cancel d-inline-flex px-2 my-auto"
                            (click)="cancelSwapMode()">
                        <span class="m-auto">{{ 'CANCEL' | translate }}</span>
                    </button>
                    <div class="w-100 d-flex">
                        <span class="ml-3 my-auto">
                            {{
                                'SWAP_SELECTED_EMPLOYEES' | translate: {
                                    x: selectedSwapEmployees.size,
                                    y: maxSwapEmployees
                                }
                            }}
                        </span>
                    </div>
                }
            </div>
        }
    </div>
</div>
